<template>
    <div class="flex items-center justify-between py-8 mt-8 text-lg font-light border-t border-grey text-text high-contrast:text-yellow-300/75 high-contrast:border-yellow-300" v-if="pagination.last_page > 1">
        <div>
            <a
                class="flex hover:text-orange text-text btn btn--arrow-left high-contrast:text-yellow-300/75"
                :class="{'disabled' : pagination.current_page <= 1}"
                href="javascript:;"
                @click.prevent="change(pagination.current_page - 1)"
            >
                <span class="hidden sm:block">{{ __('Poprzednia strona') }} </span>
            </a>
        </div>
        <ul class="flex justify-center list-reset">
            <li class="pr-2 md:pr-4" v-if="hasFirst">
                <a href="#" class="hover:text-orange" @click.prevent="change(1)">
                    <span> 1 </span>
                </a>
            </li>
            <li class="pr-0" v-if="hasStartDots">...</li>
            <li v-for="page in pages" :key="page" >
                <a
                    class="px-2 py-2 md:px-3 hover:text-orange"
                    :class="{'text-orange border-b border-orange high-contrast:border-yellow-300 high-contrast:text-yellow-300' : page == pagination.current_page}"
                    href="javascript:;"
                    @click.stop="change(page)"
                >
                    {{ page }}
                </a>
            </li>
            <li class="pr-0" v-if="hasEndDots">...</li>
            <li class="pr-2 md:pr-4" v-if="hasLast">
                <a href="#"  class="px-2 py-2 md:px-3 hover:text-orange" @click.prevent="change(pagination.last_page)">
                    <span>{{ pagination.last_page }}</span>
                </a>
            </li>
        </ul>
        <div>
            <a
                class="flex hover:text-orange text-text btn btn--arrow high-contrast:text-yellow-300/75"
                :class="{'disabled' : pagination.current_page >= pagination.last_page}"
                href="javascript:;"
                @click.prevent="change(pagination.current_page + 1)"
            >
                <span class="hidden sm:block"> {{ __('Następna strona') }} </span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            pagination: {
                type: Object,
                required: true
            },
            onEachSide: {
                type: Number,
                default: 2
            },
        },
        computed: {
            pages() {
                var pages = [];
                for (var i = this.rangeStart; i <= this.rangeEnd; i++) {
                    pages.push(i);
                }
                return pages;
            },
            rangeEnd() {
                var end = this.pagination.current_page + this.onEachSide
                return Math.min(end, this.pagination.last_page);
            },
            rangeStart() {
                var start = this.pagination.current_page  - this.onEachSide;
                return Math.max(start, 1);
            },
            hasFirst() {
                return this.rangeStart !== 1;
            },
            hasLast() {
                return this.rangeEnd < this.pagination.last_page;
            },
            hasStartDots() {
                return this.rangeStart > 2;
            },
            hasEndDots() {
                return this.rangeEnd < this.pagination.last_page - 1;
            },
        },
        methods: {
            change: function(page) {
                if(page > this.pagination.last_page || page < 1) {
                    return;
                }

                this.pagination.current_page = page;
                this.$emit('paginate');
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        }
    }
</script>
